class SwiftCity {
  cityName: string;

  constructor(cityName: string) {
    this.cityName = cityName;
  }
}

export { SwiftCity };
